import { AxiosError } from 'axios';

export type HttpError = AxiosError<{ message: string }>;

export const isHttpErrorType = (error: unknown): error is HttpError => {
	return typeof error === 'object' && error !== null && 'response' in error;
};

export type PossibleAxiosError = HttpError | Error;
